import React from "react"
import { Link } from "gatsby"
const Breadcrumb = ({
  subSlug,
  cateSlug,
  proSlug,
  category,
  subcategory,
  product,
}) => {
  return (
    <div className=" flex justify-center">
      <div className=" pb-4 w-11/12">
        {cateSlug && (
          <Link
            className="block lg:inline-block underline  font-bold"
            to={`/${cateSlug}`}
          >
            {category}
          </Link>
        )}
        {subSlug && (
          <Link
            className="block lg:inline-block font-bold  "
            to={`/${cateSlug}/${subSlug}`}
          >
            <span className="font-normal  px-2">›</span>{" "}
            <span className="underline">{subcategory}</span>
          </Link>
        )}
        {proSlug && (
          <Link
            className="block lg:inline-block font-bold "
            to={`/${cateSlug}/${subSlug}/${proSlug}`}
          >
            <span className="font-normal  px-2">›</span>
            <span className="underline">{product}</span>
          </Link>
        )}
      </div>
    </div>
  )
}

export default Breadcrumb
